import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/mdbvue.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'


Vue.config.productionTip = false
Vue.prototype.$http = axios;
Vue.prototype.bus = new Vue();

axios.interceptors.response.use(
  response => response, 
  error => {
    // Check if token is expired or invalid
    if (error.response && error.response.status === 401) {
      console.warn("JWT expired or invalid — auto-logging out.");
      // Clear user data
      store.dispatch('logout')
      // Optional: show message on login screen
      router.push({
        name: 'login',
        query: { sessionExpired: true }
      })
    }
    return Promise.reject(error)
  }
)

const token = sessionStorage.getItem('token')

if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

import * as Notify from 'mdbvue/lib/components/Notify'
Vue.use(Notify)

import * as VueSanitize from "vue-sanitize";
Vue.use(VueSanitize);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
